import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCommits: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCommits"><Circle cx="12" cy="12" r="5.5" stroke="currentColor"/><Path d="M6.5 12H1.5" stroke="currentColor" strokeLinecap="square"/><Path d="M22.5 12H17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCommits;
